// Small text helpers for Duncan's admin (M7). Prices go through
// @/lib/money (formatPence / formatPenceOr) and dates through @/lib/dates
// (formatDay / formatDateOnly / formatDayTime), so SSR and the browser print
// the same thing.

/** "1 bottle", "120 bottles". */
export function plural(count: number, one: string, many = `${one}s`) {
  return `${count.toLocaleString("en-GB")} ${count === 1 ? one : many}`
}

/** A file size: "1.6 MB", "240 KB", "900 bytes". */
export function formatBytes(bytes: number) {
  if (bytes < 1024) return `${bytes} ${bytes === 1 ? "byte" : "bytes"}`
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
  const megabytes = bytes / (1024 * 1024)
  return `${Number.isInteger(megabytes) ? megabytes : megabytes.toFixed(1)} MB`
}

/** "Order #12" for an order, "Enquiry #12" for a consultation (as in the mails and the account). */
export function enquiryTitle(enquiry: { id: number; enquiry_type: "order" | "consultation" }) {
  return `${enquiry.enquiry_type === "order" ? "Order" : "Enquiry"} #${enquiry.id}`
}
